import axios from "./request";
//定义跨域代理路由
const currentUrl = window.location.href;
const regex = /www\./;
const mobil = /mobil\./;
const phone = mobil.test(currentUrl);
const iswww = regex.test(currentUrl);

// let api =
//   process.env.NODE_ENV == "development"
//     ? "/devapi"
//     : "http://140.179.61.9:8066/csi"; //new-测试
let  api = process.env.NODE_ENV == 'development' ? '/devapi' : 'https://www.csibizsearch.com/csi'//生产
// let api = process.env.NODE_ENV == 'development' ? '/devapi' :iswww?'https://www.csibizsearch.com/prod-api': 'https://csibizsearch.com/prod-api' //生产

// 获取通知列表
export const getNotificationList = (params) => {
  return axios({
      isLoading: true,
    url: api + "/notification/getNotificationList",
    method: "GET",
    params,
  });
};

export const searchNews = (params) => {
  return axios({
    isLoading: true,
    url: api + "/csiv4/news/search",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};

export const searchNewsConditions = (params) => {
  return axios({
    isLoading: true,
    url: api + "/csiv4/news/filterConditions",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
export const searchNewsFromLoca = (params) => {
  return axios({
    isLoading: true,
    url: api + "/csiv4/newsFromLocal",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁
export const searchSanction = (params) => {
  return axios({
    isLoading: true,
    url: api + "/csiv4/riskAndComp/search",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁公司/人列表查询
export const searchSanctionList = (params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getSanctionsNew",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁人详情
export const getSanctionPersonInfo = (params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getSanctionPersonInfo",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁人详情
export const getSanctionPersonDetail = (params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getSanctionPersonEntityInfoAndSource",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁人详情-历史
export const getSanctionPersonHistory = (params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getSanctionPersonHistory",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁人详情-信息
export const getSanctionPersonData= (params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getSanctionPersonSanctionData",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁人详情-关联信息
export const getSanctionPersonRelated =(params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getSanctionPersonAssociationsInfo",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁人详情-Profile Notes
export const getSanctionProfileNotesNew =(params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getSanctionProfileNotesNew",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁模糊查询(1:公司名称；2:国家地区;3:Information Sources;4：borndate)
export const getCpSanctionSelectOptions = (params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getCpSanctionSelectOptions",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};

// 产品模糊查询(产品名称)
export const productNameSearch = params => {
  return axios.post(api + '/trade/productSearch',params)
}
// 产品模糊查询(制裁类型/国家)
export const productSanctionSelectOptions = (params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/productSanctionTypeOrRegionOptions",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 产品列表
export const productSearch = params => {
  return axios.post(api + '/trade/getProductChainSanctionsNew',params)
}
// 制裁公司详情Sanction & Official List
export const getSanctionDateSanction = (params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getSanctionPeriodNew",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁公司详情Profile Notes
export const getSanctionProfileNotes = (params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getSanctionProfileNotesNew",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁公司详情Sources
export const getSanctionDetailSource = (params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getSanctionSourceUrlNew",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
// 制裁公司详情Sanctions Related
export const getSanctionRelateInfo = (params) => {
  return axios({
    isLoading: true,
    url: api + "/publications/getSanctionRelateInfo",
    method: "GET",
    params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
};
